import React from "react";
import "./styles/Footer.css";
import { NavLink } from "react-router-dom";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import TwitterIcon from "@material-ui/icons/Twitter";
import LinkedInIcon from "@material-ui/icons/LinkedIn";

function Footer() {
  return (
    <>
      <footer className="bg-dark" id="tempaltemo_footer">
        <div className="container">
          <div className="row">
            <div className="col-md-4 pt-5">
              <h2 className="h2 text-success border-bottom pb-3 border-light logo">
                Reactjs Shop
              </h2>
              <ul className="list-unstyled text-light footer-link-list">
                <li>
                  <i className="fas fa-map-marker-alt fa-fw"></i>
                  Lahore Pakistan
                </li>
                <li>
                  <i className="fa fa-phone fa-fw"></i>
                  <NavLink
                    className="text-decoration-none"
                    to="tel:+923011234567"
                  >
                    +9230123456789
                  </NavLink>
                </li>
                <li>
                  <i className="fa fa-envelope fa-fw"></i>
                  <NavLink
                    className="text-decoration-none"
                    to="mailto:Tkshi328@gmail.com"
                  >
                    Tkshi328@gmail.com
                  </NavLink>
                </li>
              </ul>
            </div>

            <div className="col-md-4 pt-5">
              <h2 className="h2 text-light border-bottom pb-3 border-light">
                Products
              </h2>
              <ul className="list-unstyled text-light footer-link-list">
                <li>
                  <NavLink className="text-decoration-none" to="#">
                    Luxury
                  </NavLink>
                </li>
                <li>
                  <NavLink className="text-decoration-none" to="#">
                    Sport Wear
                  </NavLink>
                </li>
                <li>
                  <NavLink className="text-decoration-none" to="#">
                    Men's Shoes
                  </NavLink>
                </li>
              </ul>
            </div>

            <div className="col-md-4 pt-5">
              <h2 className="h2 text-light border-bottom pb-3 border-light">
                Further Info
              </h2>
              <ul className="list-unstyled text-light footer-link-list">
                <li>
                  <NavLink className="text-decoration-none" to="/">
                    Home
                  </NavLink>
                </li>
                <li>
                  <NavLink className="text-decoration-none" to="/about">
                    About Us
                  </NavLink>
                </li>

                <li>
                  <NavLink className="text-decoration-none" to="/contact">
                    Contact
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>

          <div className="row text-light mb-4">
            <div className="col-12 mb-3">
              <div className="w-100 my-3 border-top border-light"></div>
            </div>
            <div className="col-auto me-auto">
              <ul className="list-inline text-left footer-icons">
                <li className="list-inline-item border border-light rounded-circle text-center">
                  <NavLink
                    className="text-light text-decoration-none"
                    target="_blank"
                    to="http://facebook.com/"
                  >
                    <FacebookIcon className="Iconsmui" />
                  </NavLink>
                </li>
                <li className="list-inline-item border border-light rounded-circle text-center">
                  <NavLink
                    className="text-light text-decoration-none"
                    target="_blank"
                    to="https://www.instagram.com/"
                  >
                    <InstagramIcon className="Iconsmui" />
                  </NavLink>
                </li>
                <li className="list-inline-item border border-light rounded-circle text-center">
                  <NavLink
                    className="text-light text-decoration-none"
                    target="_blank"
                    to="https://twitter.com/"
                  >
                    <TwitterIcon className="Iconsmui" />
                  </NavLink>
                </li>
                <li className="list-inline-item border border-light rounded-circle text-center">
                  <NavLink
                    className="text-light text-decoration-none"
                    to="https://www.linkedin.com/"
                  >
                    <LinkedInIcon className="Iconsmui" />
                  </NavLink>
                </li>
              </ul>
            </div>
            <div className="col-auto">
              <label className="sr-only" htmlFor="subscribeEmail">
                Email address
              </label>
              <div className="input-group mb-2">
                <input
                  type="text"
                  className="form-control bg-dark border-light"
                  id="subscribeEmail"
                  placeholder="Email address"
                />
                <div className="input-group-text btn-success text-light">
                  Subscribe
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="w-100 bg-black py-3">
          <div className="container">
            <div className="row pt-2">
              <div className="col-12">
                <p className="text-left text-light">
                  Copyright &copy; 2021 Designed by
                  <NavLink
                    rel="sponsored"
                    to="https://www.linkedin.com/in/talha-zubair-mayo/"
                    target="_blank"
                  >
                    Talha ZuBaiR MaYo
                  </NavLink>
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
